import React, { FC } from 'react'
import FormPanel from 'components/FormPanel';
import FormButtons from 'components/FormButtons';
import useFqdn from '../hooks/useFqdn'

interface FqdnFormHeaderProps {
    title: string
    onClickSave: () => void
}

export const FqdnFormHeader: FC<FqdnFormHeaderProps> = ({ title, onClickSave }) => {
    const { goToListFqdnPage } = useFqdn()

    return (
      <FormPanel title={title}>
        <FormButtons
          isEditing
          onClickCancel={goToListFqdnPage}
          onClickSave={onClickSave}
        />
      </FormPanel>
    )
}

export default FqdnFormHeader;
